/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as PublicSetPasswordRouteImport } from './routes/_public.set-password'
import { Route as PublicOnboardRouteImport } from './routes/_public.onboard'
import { Route as PublicLoginRouteImport } from './routes/_public.login'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public.forgot-password'
import { Route as AuthedStaffRouteImport } from './routes/_authed.staff'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedRedeemRouteImport } from './routes/_authed.redeem'
import { Route as AuthedReceiptsRouteImport } from './routes/_authed.receipts'
import { Route as AuthedNotificationsRouteImport } from './routes/_authed.notifications'
import { Route as AuthedMediaRouteImport } from './routes/_authed.media'
import { Route as AuthedLoyaltyRouteImport } from './routes/_authed.loyalty'
import { Route as AuthedInventoryRouteImport } from './routes/_authed.inventory'
import { Route as AuthedDevicesRouteImport } from './routes/_authed.devices'
import { Route as AuthedDealsRouteImport } from './routes/_authed.deals'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedBranchesRouteImport } from './routes/_authed.branches'
import { Route as AuthedAnalyticsRouteImport } from './routes/_authed.analytics'
import { Route as PublicOnboardIndexRouteImport } from './routes/_public.onboard.index'
import { Route as PublicLoginIndexRouteImport } from './routes/_public.login.index'
import { Route as AuthedStaffIndexRouteImport } from './routes/_authed.staff.index'
import { Route as AuthedReceiptsIndexRouteImport } from './routes/_authed.receipts.index'
import { Route as AuthedInventoryIndexRouteImport } from './routes/_authed.inventory.index'
import { Route as AuthedDealsIndexRouteImport } from './routes/_authed.deals.index'
import { Route as AuthedAnalyticsIndexRouteImport } from './routes/_authed.analytics.index'
import { Route as PublicOnboardCodeRouteImport } from './routes/_public.onboard.code'
import { Route as PublicLoginVerifyRouteImport } from './routes/_public.login.verify'
import { Route as PublicLoginSmsRouteImport } from './routes/_public.login.sms'
import { Route as AuthedStaffNewRouteImport } from './routes/_authed.staff.new'
import { Route as AuthedReceiptsTransactionIdRouteImport } from './routes/_authed.receipts.$transactionId'
import { Route as AuthedInventoryProductIdRouteImport } from './routes/_authed.inventory.$productId'
import { Route as AuthedDealsNewRouteImport } from './routes/_authed.deals.new'
import { Route as AuthedDealsDealIdRouteImport } from './routes/_authed.deals.$dealId'
import { Route as AuthedAnalyticsStoreReportRouteImport } from './routes/_authed.analytics.store-report'
import { Route as AuthedAnalyticsPipelineRouteImport } from './routes/_authed.analytics.pipeline'
import { Route as AuthedAnalyticsInventoryRouteImport } from './routes/_authed.analytics.inventory'
import { Route as AuthedAnalyticsEngagementRouteImport } from './routes/_authed.analytics.engagement'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicSetPasswordRoute = PublicSetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicOnboardRoute = PublicOnboardRouteImport.update({
  id: '/onboard',
  path: '/onboard',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const AuthedStaffRoute = AuthedStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRedeemRoute = AuthedRedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReceiptsRoute = AuthedReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNotificationsRoute = AuthedNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMediaRoute = AuthedMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLoyaltyRoute = AuthedLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInventoryRoute = AuthedInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDevicesRoute = AuthedDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDealsRoute = AuthedDealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBranchesRoute = AuthedBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsRoute = AuthedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthedRoute,
} as any)
const PublicOnboardIndexRoute = PublicOnboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicOnboardRoute,
} as any)
const PublicLoginIndexRoute = PublicLoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicLoginRoute,
} as any)
const AuthedStaffIndexRoute = AuthedStaffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedReceiptsIndexRoute = AuthedReceiptsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedReceiptsRoute,
} as any)
const AuthedInventoryIndexRoute = AuthedInventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedInventoryRoute,
} as any)
const AuthedDealsIndexRoute = AuthedDealsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedDealsRoute,
} as any)
const AuthedAnalyticsIndexRoute = AuthedAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const PublicOnboardCodeRoute = PublicOnboardCodeRouteImport.update({
  id: '/code',
  path: '/code',
  getParentRoute: () => PublicOnboardRoute,
} as any)
const PublicLoginVerifyRoute = PublicLoginVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => PublicLoginRoute,
} as any)
const PublicLoginSmsRoute = PublicLoginSmsRouteImport.update({
  id: '/sms',
  path: '/sms',
  getParentRoute: () => PublicLoginRoute,
} as any)
const AuthedStaffNewRoute = AuthedStaffNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedStaffRoute,
} as any)
const AuthedReceiptsTransactionIdRoute =
  AuthedReceiptsTransactionIdRouteImport.update({
    id: '/$transactionId',
    path: '/$transactionId',
    getParentRoute: () => AuthedReceiptsRoute,
  } as any)
const AuthedInventoryProductIdRoute =
  AuthedInventoryProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AuthedInventoryRoute,
  } as any)
const AuthedDealsNewRoute = AuthedDealsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedDealsRoute,
} as any)
const AuthedDealsDealIdRoute = AuthedDealsDealIdRouteImport.update({
  id: '/$dealId',
  path: '/$dealId',
  getParentRoute: () => AuthedDealsRoute,
} as any)
const AuthedAnalyticsStoreReportRoute =
  AuthedAnalyticsStoreReportRouteImport.update({
    id: '/store-report',
    path: '/store-report',
    getParentRoute: () => AuthedAnalyticsRoute,
  } as any)
const AuthedAnalyticsPipelineRoute = AuthedAnalyticsPipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => AuthedAnalyticsRoute,
} as any)
const AuthedAnalyticsInventoryRoute =
  AuthedAnalyticsInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthedAnalyticsRoute,
  } as any)
const AuthedAnalyticsEngagementRoute =
  AuthedAnalyticsEngagementRouteImport.update({
    id: '/engagement',
    path: '/engagement',
    getParentRoute: () => AuthedAnalyticsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/analytics': typeof AuthedAnalyticsRouteWithChildren
  '/branches': typeof AuthedBranchesRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/deals': typeof AuthedDealsRouteWithChildren
  '/devices': typeof AuthedDevicesRoute
  '/inventory': typeof AuthedInventoryRouteWithChildren
  '/loyalty': typeof AuthedLoyaltyRoute
  '/media': typeof AuthedMediaRoute
  '/notifications': typeof AuthedNotificationsRoute
  '/receipts': typeof AuthedReceiptsRouteWithChildren
  '/redeem': typeof AuthedRedeemRoute
  '/settings': typeof AuthedSettingsRoute
  '/staff': typeof AuthedStaffRouteWithChildren
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRouteWithChildren
  '/onboard': typeof PublicOnboardRouteWithChildren
  '/set-password': typeof PublicSetPasswordRoute
  '/analytics/engagement': typeof AuthedAnalyticsEngagementRoute
  '/analytics/inventory': typeof AuthedAnalyticsInventoryRoute
  '/analytics/pipeline': typeof AuthedAnalyticsPipelineRoute
  '/analytics/store-report': typeof AuthedAnalyticsStoreReportRoute
  '/deals/$dealId': typeof AuthedDealsDealIdRoute
  '/deals/new': typeof AuthedDealsNewRoute
  '/inventory/$productId': typeof AuthedInventoryProductIdRoute
  '/receipts/$transactionId': typeof AuthedReceiptsTransactionIdRoute
  '/staff/new': typeof AuthedStaffNewRoute
  '/login/sms': typeof PublicLoginSmsRoute
  '/login/verify': typeof PublicLoginVerifyRoute
  '/onboard/code': typeof PublicOnboardCodeRoute
  '/analytics/': typeof AuthedAnalyticsIndexRoute
  '/deals/': typeof AuthedDealsIndexRoute
  '/inventory/': typeof AuthedInventoryIndexRoute
  '/receipts/': typeof AuthedReceiptsIndexRoute
  '/staff/': typeof AuthedStaffIndexRoute
  '/login/': typeof PublicLoginIndexRoute
  '/onboard/': typeof PublicOnboardIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/branches': typeof AuthedBranchesRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/devices': typeof AuthedDevicesRoute
  '/loyalty': typeof AuthedLoyaltyRoute
  '/media': typeof AuthedMediaRoute
  '/notifications': typeof AuthedNotificationsRoute
  '/redeem': typeof AuthedRedeemRoute
  '/settings': typeof AuthedSettingsRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/set-password': typeof PublicSetPasswordRoute
  '/analytics/engagement': typeof AuthedAnalyticsEngagementRoute
  '/analytics/inventory': typeof AuthedAnalyticsInventoryRoute
  '/analytics/pipeline': typeof AuthedAnalyticsPipelineRoute
  '/analytics/store-report': typeof AuthedAnalyticsStoreReportRoute
  '/deals/$dealId': typeof AuthedDealsDealIdRoute
  '/deals/new': typeof AuthedDealsNewRoute
  '/inventory/$productId': typeof AuthedInventoryProductIdRoute
  '/receipts/$transactionId': typeof AuthedReceiptsTransactionIdRoute
  '/staff/new': typeof AuthedStaffNewRoute
  '/login/sms': typeof PublicLoginSmsRoute
  '/login/verify': typeof PublicLoginVerifyRoute
  '/onboard/code': typeof PublicOnboardCodeRoute
  '/analytics': typeof AuthedAnalyticsIndexRoute
  '/deals': typeof AuthedDealsIndexRoute
  '/inventory': typeof AuthedInventoryIndexRoute
  '/receipts': typeof AuthedReceiptsIndexRoute
  '/staff': typeof AuthedStaffIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/onboard': typeof PublicOnboardIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authed/analytics': typeof AuthedAnalyticsRouteWithChildren
  '/_authed/branches': typeof AuthedBranchesRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/deals': typeof AuthedDealsRouteWithChildren
  '/_authed/devices': typeof AuthedDevicesRoute
  '/_authed/inventory': typeof AuthedInventoryRouteWithChildren
  '/_authed/loyalty': typeof AuthedLoyaltyRoute
  '/_authed/media': typeof AuthedMediaRoute
  '/_authed/notifications': typeof AuthedNotificationsRoute
  '/_authed/receipts': typeof AuthedReceiptsRouteWithChildren
  '/_authed/redeem': typeof AuthedRedeemRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/staff': typeof AuthedStaffRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRouteWithChildren
  '/_public/onboard': typeof PublicOnboardRouteWithChildren
  '/_public/set-password': typeof PublicSetPasswordRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/analytics/engagement': typeof AuthedAnalyticsEngagementRoute
  '/_authed/analytics/inventory': typeof AuthedAnalyticsInventoryRoute
  '/_authed/analytics/pipeline': typeof AuthedAnalyticsPipelineRoute
  '/_authed/analytics/store-report': typeof AuthedAnalyticsStoreReportRoute
  '/_authed/deals/$dealId': typeof AuthedDealsDealIdRoute
  '/_authed/deals/new': typeof AuthedDealsNewRoute
  '/_authed/inventory/$productId': typeof AuthedInventoryProductIdRoute
  '/_authed/receipts/$transactionId': typeof AuthedReceiptsTransactionIdRoute
  '/_authed/staff/new': typeof AuthedStaffNewRoute
  '/_public/login/sms': typeof PublicLoginSmsRoute
  '/_public/login/verify': typeof PublicLoginVerifyRoute
  '/_public/onboard/code': typeof PublicOnboardCodeRoute
  '/_authed/analytics/': typeof AuthedAnalyticsIndexRoute
  '/_authed/deals/': typeof AuthedDealsIndexRoute
  '/_authed/inventory/': typeof AuthedInventoryIndexRoute
  '/_authed/receipts/': typeof AuthedReceiptsIndexRoute
  '/_authed/staff/': typeof AuthedStaffIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_public/onboard/': typeof PublicOnboardIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/branches'
    | '/dashboard'
    | '/deals'
    | '/devices'
    | '/inventory'
    | '/loyalty'
    | '/media'
    | '/notifications'
    | '/receipts'
    | '/redeem'
    | '/settings'
    | '/staff'
    | '/forgot-password'
    | '/login'
    | '/onboard'
    | '/set-password'
    | '/analytics/engagement'
    | '/analytics/inventory'
    | '/analytics/pipeline'
    | '/analytics/store-report'
    | '/deals/$dealId'
    | '/deals/new'
    | '/inventory/$productId'
    | '/receipts/$transactionId'
    | '/staff/new'
    | '/login/sms'
    | '/login/verify'
    | '/onboard/code'
    | '/analytics/'
    | '/deals/'
    | '/inventory/'
    | '/receipts/'
    | '/staff/'
    | '/login/'
    | '/onboard/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/branches'
    | '/dashboard'
    | '/devices'
    | '/loyalty'
    | '/media'
    | '/notifications'
    | '/redeem'
    | '/settings'
    | '/forgot-password'
    | '/set-password'
    | '/analytics/engagement'
    | '/analytics/inventory'
    | '/analytics/pipeline'
    | '/analytics/store-report'
    | '/deals/$dealId'
    | '/deals/new'
    | '/inventory/$productId'
    | '/receipts/$transactionId'
    | '/staff/new'
    | '/login/sms'
    | '/login/verify'
    | '/onboard/code'
    | '/analytics'
    | '/deals'
    | '/inventory'
    | '/receipts'
    | '/staff'
    | '/login'
    | '/onboard'
  id:
    | '__root__'
    | '/_authed'
    | '/_public'
    | '/_authed/analytics'
    | '/_authed/branches'
    | '/_authed/dashboard'
    | '/_authed/deals'
    | '/_authed/devices'
    | '/_authed/inventory'
    | '/_authed/loyalty'
    | '/_authed/media'
    | '/_authed/notifications'
    | '/_authed/receipts'
    | '/_authed/redeem'
    | '/_authed/settings'
    | '/_authed/staff'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/onboard'
    | '/_public/set-password'
    | '/_authed/'
    | '/_authed/analytics/engagement'
    | '/_authed/analytics/inventory'
    | '/_authed/analytics/pipeline'
    | '/_authed/analytics/store-report'
    | '/_authed/deals/$dealId'
    | '/_authed/deals/new'
    | '/_authed/inventory/$productId'
    | '/_authed/receipts/$transactionId'
    | '/_authed/staff/new'
    | '/_public/login/sms'
    | '/_public/login/verify'
    | '/_public/onboard/code'
    | '/_authed/analytics/'
    | '/_authed/deals/'
    | '/_authed/inventory/'
    | '/_authed/receipts/'
    | '/_authed/staff/'
    | '/_public/login/'
    | '/_public/onboard/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/set-password': {
      id: '/_public/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof PublicSetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/onboard': {
      id: '/_public/onboard'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof PublicOnboardRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authed/staff': {
      id: '/_authed/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthedStaffRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/redeem': {
      id: '/_authed/redeem'
      path: '/redeem'
      fullPath: '/redeem'
      preLoaderRoute: typeof AuthedRedeemRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/receipts': {
      id: '/_authed/receipts'
      path: '/receipts'
      fullPath: '/receipts'
      preLoaderRoute: typeof AuthedReceiptsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/notifications': {
      id: '/_authed/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthedNotificationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/media': {
      id: '/_authed/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof AuthedMediaRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/loyalty': {
      id: '/_authed/loyalty'
      path: '/loyalty'
      fullPath: '/loyalty'
      preLoaderRoute: typeof AuthedLoyaltyRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inventory': {
      id: '/_authed/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AuthedInventoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/devices': {
      id: '/_authed/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthedDevicesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/deals': {
      id: '/_authed/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof AuthedDealsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/branches': {
      id: '/_authed/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof AuthedBranchesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics': {
      id: '/_authed/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthedAnalyticsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_public/onboard/': {
      id: '/_public/onboard/'
      path: '/'
      fullPath: '/onboard/'
      preLoaderRoute: typeof PublicOnboardIndexRouteImport
      parentRoute: typeof PublicOnboardRoute
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof PublicLoginIndexRouteImport
      parentRoute: typeof PublicLoginRoute
    }
    '/_authed/staff/': {
      id: '/_authed/staff/'
      path: '/'
      fullPath: '/staff/'
      preLoaderRoute: typeof AuthedStaffIndexRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/receipts/': {
      id: '/_authed/receipts/'
      path: '/'
      fullPath: '/receipts/'
      preLoaderRoute: typeof AuthedReceiptsIndexRouteImport
      parentRoute: typeof AuthedReceiptsRoute
    }
    '/_authed/inventory/': {
      id: '/_authed/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AuthedInventoryIndexRouteImport
      parentRoute: typeof AuthedInventoryRoute
    }
    '/_authed/deals/': {
      id: '/_authed/deals/'
      path: '/'
      fullPath: '/deals/'
      preLoaderRoute: typeof AuthedDealsIndexRouteImport
      parentRoute: typeof AuthedDealsRoute
    }
    '/_authed/analytics/': {
      id: '/_authed/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthedAnalyticsIndexRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_public/onboard/code': {
      id: '/_public/onboard/code'
      path: '/code'
      fullPath: '/onboard/code'
      preLoaderRoute: typeof PublicOnboardCodeRouteImport
      parentRoute: typeof PublicOnboardRoute
    }
    '/_public/login/verify': {
      id: '/_public/login/verify'
      path: '/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof PublicLoginVerifyRouteImport
      parentRoute: typeof PublicLoginRoute
    }
    '/_public/login/sms': {
      id: '/_public/login/sms'
      path: '/sms'
      fullPath: '/login/sms'
      preLoaderRoute: typeof PublicLoginSmsRouteImport
      parentRoute: typeof PublicLoginRoute
    }
    '/_authed/staff/new': {
      id: '/_authed/staff/new'
      path: '/new'
      fullPath: '/staff/new'
      preLoaderRoute: typeof AuthedStaffNewRouteImport
      parentRoute: typeof AuthedStaffRoute
    }
    '/_authed/receipts/$transactionId': {
      id: '/_authed/receipts/$transactionId'
      path: '/$transactionId'
      fullPath: '/receipts/$transactionId'
      preLoaderRoute: typeof AuthedReceiptsTransactionIdRouteImport
      parentRoute: typeof AuthedReceiptsRoute
    }
    '/_authed/inventory/$productId': {
      id: '/_authed/inventory/$productId'
      path: '/$productId'
      fullPath: '/inventory/$productId'
      preLoaderRoute: typeof AuthedInventoryProductIdRouteImport
      parentRoute: typeof AuthedInventoryRoute
    }
    '/_authed/deals/new': {
      id: '/_authed/deals/new'
      path: '/new'
      fullPath: '/deals/new'
      preLoaderRoute: typeof AuthedDealsNewRouteImport
      parentRoute: typeof AuthedDealsRoute
    }
    '/_authed/deals/$dealId': {
      id: '/_authed/deals/$dealId'
      path: '/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AuthedDealsDealIdRouteImport
      parentRoute: typeof AuthedDealsRoute
    }
    '/_authed/analytics/store-report': {
      id: '/_authed/analytics/store-report'
      path: '/store-report'
      fullPath: '/analytics/store-report'
      preLoaderRoute: typeof AuthedAnalyticsStoreReportRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/pipeline': {
      id: '/_authed/analytics/pipeline'
      path: '/pipeline'
      fullPath: '/analytics/pipeline'
      preLoaderRoute: typeof AuthedAnalyticsPipelineRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/inventory': {
      id: '/_authed/analytics/inventory'
      path: '/inventory'
      fullPath: '/analytics/inventory'
      preLoaderRoute: typeof AuthedAnalyticsInventoryRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
    '/_authed/analytics/engagement': {
      id: '/_authed/analytics/engagement'
      path: '/engagement'
      fullPath: '/analytics/engagement'
      preLoaderRoute: typeof AuthedAnalyticsEngagementRouteImport
      parentRoute: typeof AuthedAnalyticsRoute
    }
  }
}

interface AuthedAnalyticsRouteChildren {
  AuthedAnalyticsEngagementRoute: typeof AuthedAnalyticsEngagementRoute
  AuthedAnalyticsInventoryRoute: typeof AuthedAnalyticsInventoryRoute
  AuthedAnalyticsPipelineRoute: typeof AuthedAnalyticsPipelineRoute
  AuthedAnalyticsStoreReportRoute: typeof AuthedAnalyticsStoreReportRoute
  AuthedAnalyticsIndexRoute: typeof AuthedAnalyticsIndexRoute
}

const AuthedAnalyticsRouteChildren: AuthedAnalyticsRouteChildren = {
  AuthedAnalyticsEngagementRoute: AuthedAnalyticsEngagementRoute,
  AuthedAnalyticsInventoryRoute: AuthedAnalyticsInventoryRoute,
  AuthedAnalyticsPipelineRoute: AuthedAnalyticsPipelineRoute,
  AuthedAnalyticsStoreReportRoute: AuthedAnalyticsStoreReportRoute,
  AuthedAnalyticsIndexRoute: AuthedAnalyticsIndexRoute,
}

const AuthedAnalyticsRouteWithChildren = AuthedAnalyticsRoute._addFileChildren(
  AuthedAnalyticsRouteChildren,
)

interface AuthedDealsRouteChildren {
  AuthedDealsDealIdRoute: typeof AuthedDealsDealIdRoute
  AuthedDealsNewRoute: typeof AuthedDealsNewRoute
  AuthedDealsIndexRoute: typeof AuthedDealsIndexRoute
}

const AuthedDealsRouteChildren: AuthedDealsRouteChildren = {
  AuthedDealsDealIdRoute: AuthedDealsDealIdRoute,
  AuthedDealsNewRoute: AuthedDealsNewRoute,
  AuthedDealsIndexRoute: AuthedDealsIndexRoute,
}

const AuthedDealsRouteWithChildren = AuthedDealsRoute._addFileChildren(
  AuthedDealsRouteChildren,
)

interface AuthedInventoryRouteChildren {
  AuthedInventoryProductIdRoute: typeof AuthedInventoryProductIdRoute
  AuthedInventoryIndexRoute: typeof AuthedInventoryIndexRoute
}

const AuthedInventoryRouteChildren: AuthedInventoryRouteChildren = {
  AuthedInventoryProductIdRoute: AuthedInventoryProductIdRoute,
  AuthedInventoryIndexRoute: AuthedInventoryIndexRoute,
}

const AuthedInventoryRouteWithChildren = AuthedInventoryRoute._addFileChildren(
  AuthedInventoryRouteChildren,
)

interface AuthedReceiptsRouteChildren {
  AuthedReceiptsTransactionIdRoute: typeof AuthedReceiptsTransactionIdRoute
  AuthedReceiptsIndexRoute: typeof AuthedReceiptsIndexRoute
}

const AuthedReceiptsRouteChildren: AuthedReceiptsRouteChildren = {
  AuthedReceiptsTransactionIdRoute: AuthedReceiptsTransactionIdRoute,
  AuthedReceiptsIndexRoute: AuthedReceiptsIndexRoute,
}

const AuthedReceiptsRouteWithChildren = AuthedReceiptsRoute._addFileChildren(
  AuthedReceiptsRouteChildren,
)

interface AuthedStaffRouteChildren {
  AuthedStaffNewRoute: typeof AuthedStaffNewRoute
  AuthedStaffIndexRoute: typeof AuthedStaffIndexRoute
}

const AuthedStaffRouteChildren: AuthedStaffRouteChildren = {
  AuthedStaffNewRoute: AuthedStaffNewRoute,
  AuthedStaffIndexRoute: AuthedStaffIndexRoute,
}

const AuthedStaffRouteWithChildren = AuthedStaffRoute._addFileChildren(
  AuthedStaffRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAnalyticsRoute: typeof AuthedAnalyticsRouteWithChildren
  AuthedBranchesRoute: typeof AuthedBranchesRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDealsRoute: typeof AuthedDealsRouteWithChildren
  AuthedDevicesRoute: typeof AuthedDevicesRoute
  AuthedInventoryRoute: typeof AuthedInventoryRouteWithChildren
  AuthedLoyaltyRoute: typeof AuthedLoyaltyRoute
  AuthedMediaRoute: typeof AuthedMediaRoute
  AuthedNotificationsRoute: typeof AuthedNotificationsRoute
  AuthedReceiptsRoute: typeof AuthedReceiptsRouteWithChildren
  AuthedRedeemRoute: typeof AuthedRedeemRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedStaffRoute: typeof AuthedStaffRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAnalyticsRoute: AuthedAnalyticsRouteWithChildren,
  AuthedBranchesRoute: AuthedBranchesRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDealsRoute: AuthedDealsRouteWithChildren,
  AuthedDevicesRoute: AuthedDevicesRoute,
  AuthedInventoryRoute: AuthedInventoryRouteWithChildren,
  AuthedLoyaltyRoute: AuthedLoyaltyRoute,
  AuthedMediaRoute: AuthedMediaRoute,
  AuthedNotificationsRoute: AuthedNotificationsRoute,
  AuthedReceiptsRoute: AuthedReceiptsRouteWithChildren,
  AuthedRedeemRoute: AuthedRedeemRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedStaffRoute: AuthedStaffRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface PublicLoginRouteChildren {
  PublicLoginSmsRoute: typeof PublicLoginSmsRoute
  PublicLoginVerifyRoute: typeof PublicLoginVerifyRoute
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
}

const PublicLoginRouteChildren: PublicLoginRouteChildren = {
  PublicLoginSmsRoute: PublicLoginSmsRoute,
  PublicLoginVerifyRoute: PublicLoginVerifyRoute,
  PublicLoginIndexRoute: PublicLoginIndexRoute,
}

const PublicLoginRouteWithChildren = PublicLoginRoute._addFileChildren(
  PublicLoginRouteChildren,
)

interface PublicOnboardRouteChildren {
  PublicOnboardCodeRoute: typeof PublicOnboardCodeRoute
  PublicOnboardIndexRoute: typeof PublicOnboardIndexRoute
}

const PublicOnboardRouteChildren: PublicOnboardRouteChildren = {
  PublicOnboardCodeRoute: PublicOnboardCodeRoute,
  PublicOnboardIndexRoute: PublicOnboardIndexRoute,
}

const PublicOnboardRouteWithChildren = PublicOnboardRoute._addFileChildren(
  PublicOnboardRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRouteWithChildren
  PublicOnboardRoute: typeof PublicOnboardRouteWithChildren
  PublicSetPasswordRoute: typeof PublicSetPasswordRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRouteWithChildren,
  PublicOnboardRoute: PublicOnboardRouteWithChildren,
  PublicSetPasswordRoute: PublicSetPasswordRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
